<template>
  <v-container :class="containerClass" fluid></v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
export default {
  name: 'Role',
  layout: LayoutDashboard,
}
</script>
